/**
 * Check if user is on mobile
 *
 * @return {Void}
 */
 export const deviceIsMobile = () => $(window).outerWidth() <= 1023;
